import { useEffect } from "react";
import Animated, {
	useAnimatedStyle,
	useSharedValue,
	withDelay,
	withRepeat,
	withSequence,
	withSpring,
} from "react-native-reanimated";
import { SpringConfig } from "react-native-reanimated/lib/typescript/animation/springUtils";
import { Image } from "src/swsh-native";
import { ParsedScatteredSticker } from "../types";

const springConfig: SpringConfig = {
	damping: 8,
	stiffness: 50,
	mass: 2,
	restSpeedThreshold: 0.01,
};
const AnimatedScatteredSticker = ({ sticker }: { sticker: ParsedScatteredSticker }) => {
	const rotateSV = useSharedValue(0);
	useEffect(() => {
		rotateSV.value = withDelay(
			sticker.animationDelay,
			withRepeat(
				withSequence(
					withSpring(sticker.rotation, springConfig),
					withSpring(-sticker.rotation, springConfig),
					withSpring(0, springConfig),
				),
				-1,
				sticker.animationReverse,
			),
		);
	}, [rotateSV, sticker.animationDelay, sticker.animationReverse, sticker.rotation]);
	const animatedStyle = useAnimatedStyle(
		() => ({
			transform: [
				{
					translateX: sticker.x,
				},
				{
					translateY: sticker.y,
				},
				{ rotate: `${rotateSV.value}deg` },
			],
		}),
		[rotateSV, sticker.x, sticker.y],
	);

	return (
		<Animated.View
			pointerEvents="none"
			style={[
				{
					position: "absolute",
					width: sticker.size,
					height: sticker.size,
				},
				animatedStyle,
			]}
		>
			<Image
				pointerEvents="none"
				src={sticker.url}
				alt=""
				dim={{
					width: sticker.size,
					height: sticker.size,
				}}
				contentFit="contain"
			/>
		</Animated.View>
	);
};
export default AnimatedScatteredSticker;
